import React from 'react';
import imagenFondo from '../assets/logo_elecnor.jpg';

const PTWPdfTemplate = React.forwardRef(({ ptw, catalogo, firmasSecciones, seleccionados = [], renovaciones, bloqueos, descargos, mecanicos, trabajosPrevios }, ref) => {
    
    if (!ptw) return null;

    // --- HELPERS ---
    const idsSeleccionados = seleccionados && seleccionados.length > 0
        ? seleccionados
        : (ptw.riesgos_ptw_manual || [
            ...(ptw.hpt?.riesgos_detallados?.map(r => r.id_item) || []),
            ...(ptw.hpt?.medidas_detalladas?.map(m => m.id_item) || [])
            ]);

    const getRiesgosAgrupados = () => {
        if (!idsSeleccionados || idsSeleccionados.length === 0) return {};
        
        const riesgosSel = catalogo.filter(i => 
            (i.es_riesgo === 1 || i.es_riesgo === true) && idsSeleccionados.includes(i.id_item)
        );
        
        const grupos = {};
        riesgosSel.forEach(r => {
            const cat = r.categoria || 'OTROS RIESGOS';
            if (!grupos[cat]) grupos[cat] = [];
            grupos[cat].push(r.descripcion);
        });
        
        return grupos;
    };

    const getMedidas = () => {
        if (!idsSeleccionados || idsSeleccionados.length === 0) return [];
        return catalogo
            .filter(i => (i.es_riesgo === 0 || i.es_riesgo === false) && idsSeleccionados.includes(i.id_item))
            .map(i => i.descripcion);
    };

    const getFirma = (seccion, rol) => firmasSecciones?.[seccion]?.[rol] || {};
    const intervieneSubcontrata = ptw.hpt?.interviene_subcontrata === 1 || ptw.hpt?.interviene_subcontrata === true;

    // --- ESTILOS GENERALES---
    const s = {
        wrapper: { backgroundColor: '#fff', color: '#000', margin: '0 auto', fontFamily: 'Arial, sans-serif'},
        page: { width: '210mm', minHeight: '297mm', padding: '6mm', boxSizing: 'border-box', position: 'relative'},
        header: {display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid black'},
        title: { textAlign: 'center', fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase' },
        table: { width: '100%', borderCollapse: 'collapse', marginBottom: '4px', border: '1px solid black' },
        th: { border: '1px solid #000', backgroundColor: '#e0e0e0', padding: '2px', fontWeight: 'bold', textAlign: 'left', fontSize: '8.5px' },
        td: { padding: '2px', verticalAlign: 'top', fontSize: '7px' },
        tdLabel: { border: '1px solid #000', padding: '2px', fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '100px', fontSize: '8px' },
        signBox: { height: '30px', border: '1px dashed #ccc', marginTop: '1px', textAlign: 'center', backgroundColor: '#fafafa', position: 'relative' },
        signImg: { maxHeight: '100%', maxWidth: '100%' },
        smallText: { fontSize: '6.5px', color: '#555', fontStyle: 'italic', marginTop: '1px' }
    };

    return (
        <div ref={ref} style={s.wrapper}>
            {/* ========================================================================= */}
            {/* PÁGINA 1: PTW */}
            {/* ========================================================================= */}
            <div style={s.page}>
                {/* CABECERA */}
                <div style={s.header}>
                    <div><img src = {imagenFondo} style={{ maxHeight: '40px'}}></img></div>
                    <div style={s.title}>PERMISO DE TRABAJO rev05</div>
                    <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '11px' }}>Nº: {ptw.id_ptw_formato}</div>
                </div>

                {/* DATOS GENERALES */}
                <table style={s.table}>
                    <tbody>
                        <tr>
                            <td style={{...s.tdLabel, width: '150px'}}>ALCANCE:</td>
                            <td style={s.td} colSpan="3">{ptw.alcance}</td>
                        </tr>
                        <tr>
                            <td style={{...s.tdLabel, width: '150px'}}>SOLICITANTE:</td>
                            <td style={s.td} colSpan="3">{ptw.solicitante_nombre}</td>
                        </tr>
                        <tr>
                            <td style={{...s.tdLabel, width: '150px'}}>FECHA:</td>
                            <td style={s.td}>{ptw.fecha_trabajo}</td>
                            <td style={{...s.tdLabel, width: '60px'}}>HORA:</td>
                            <td style={s.td}>{ptw.rango_horario}</td>
                        </tr>
                        <tr>
                            <td style={{...s.tdLabel, width: '150px'}}>ACTIVO/DEN.ACT./OT ASOCIADA:</td>
                            <td style={s.td} colSpan="3">{ptw.codigo_activo} / {ptw.den_act_snapshot} / {ptw.ot_asociada || 'N/A'}</td>
                        </tr>
                    </tbody>
                </table>

                {/* DESCARGOS Y CONSIGNACIÓN */}
                <table style={{...s.table, marginBottom: '0px', borderBottom: 0}}>
                    <thead>
                        <tr><th colSpan="3" style={s.th}>DESCARGOS</th></tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{...s.td, width: '33%', verticalAlign: 'top'}}>
                                {bloqueos.length === 0 ? '-' : (
                                    <ul style={{ margin: '4px 0 0 0', paddingLeft: '15px' }}>
                                        {bloqueos.map((b, i) => <li key={'b'+i}>BLOQUEO ELÉCTRICO {b.num_consignacion}</li>)}
                                    </ul>
                                )}
                            </td>
                            <td style={{...s.td, width: '33%', verticalAlign: 'top'}}>
                                {descargos.length === 0 ? '-' : (
                                    <ul style={{ margin: '4px 0 0 0', paddingLeft: '15px' }}>
                                        {descargos.map((d, i) => <li key={'b'+i}>DESCARGO ELÉCTRICO {d.num_consignacion}</li>)}
                                    </ul>
                                )}
                            </td>
                            <td style={{...s.td, width: '33%', verticalAlign: 'top'}}>
                                {mecanicos.length === 0 ? '-' : (
                                    <ul style={{ margin: '4px 0 0 0', paddingLeft: '15px' }}>
                                        {mecanicos.map((m, i) => <li key={'b'+i}>DESCARGO MECÁNICO {m}</li>)}
                                    </ul>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table style={s.table}>
                    <thead>
                        <tr style={{ height: '40px' }}>
                            <th style={{ ...s.th, width: '25%', textAlign: 'center', verticalAlign: 'middle' }}>
                                <span style={{ textDecoration: 'underline' }}>TRABAJOS PREVIOS<br/>OPERACIONES</span>
                            </th>
                            
                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                REALIZADO /<br/>VERIFICADO<br/>JEFE TURNO (en campo)
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('consignacion', 'Jefe de Turno').firma_path && <img src={getFirma('consignacion', 'Jefe de Turno').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('consignacion', 'Jefe de Turno').nombre}<br/>
                                {getFirma('consignacion', 'Jefe de Turno').fecha_hora}<br/>
                            </th>

                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                COMPROBADO<br/>JEFE TRABAJO (en campo)
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('consignacion', 'Jefe de Trabajo').firma_path && <img src={getFirma('consignacion', 'Jefe de Trabajo').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('consignacion', 'Jefe de Trabajo').nombre}<br/>
                                {getFirma('consignacion', 'Jefe de Trabajo').fecha_hora}<br/>
                            </th>

                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                COMPROBADO<br/>RESPONSABLE DE<br/>CONTRATA (en campo)*
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('consignacion', 'Resp. Contrata').firma_path && <img src={getFirma('consignacion', 'Resp. Contrata').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('consignacion', 'Resp. Contrata').nombre}<br/>
                                {getFirma('consignacion', 'Resp. Contrata').fecha_hora}<br/>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td style={{...s.td, verticalAlign: 'top'}}>
                                {bloqueos.length === 0 && descargos.length === 0 && mecanicos.length === 0 && trabajosPrevios.length === 0 ? null : (
                                    <ul style={{ margin: '4px 0 0 0', paddingLeft: '15px', fontSize: '7px' }}>
                                        {bloqueos.map((b, i) => <li key={'b'+i}>BLOQUEO ELÉCTRICO {b.num_consignacion}</li>)}
                                        {descargos.map((d, i) => <li key={'b'+i}>DESCARGO ELÉCTRICO {d.num_consignacion}</li>)}
                                        {mecanicos.map((m, i) => <li key={'b'+i}>DESCARGO MECÁNICO {m}</li>)}
                                        {trabajosPrevios.map((tp, i) => <li key={'b'+i}>{tp}</li>)}
                                    </ul>
                                )}
                            </td>
                            <td style={s.td} colSpan = "4"></td>
                            <td style={{...s.td, border: '1px solid black', alignContent: 'center', fontSize: '6.5px'}} colSpan = "2">* El Responsable de la subcontrata actuará también como Recurso Preventivo en los trabajos afectados por el RD 1627/97.</td>
                        </tr>
                        <tr>
                            <td style={s.td} colSpan = "2"><strong>CAJA Nº:</strong> {ptw.numero_caja}</td>
                            <td style={s.td} colSpan = "2"><strong>CANDADO OPERACIÓN:</strong> {ptw.candado_operacion}</td>
                            <td style={s.td} colSpan = "2"><strong>CANDADO EJECUTANTE:</strong> {ptw.candado_ejecutante}</td>
                        </tr>
                    </tbody>
                </table>

                {/* RIESGOS */}
                <table style={s.table}>
                    <thead><tr><th style={s.th}>RIESGOS</th></tr></thead>
                    <tbody>
                        {Object.keys(getRiesgosAgrupados()).length === 0 ? (
                            <tr><td style={s.td}>Ninguno seleccionado.</td></tr>
                        ) : (
                            Object.entries(getRiesgosAgrupados()).map(([categoria, listaRiesgos], idx) => (
                                <tr key={idx}>
                                    <td style={{...s.td, fontSize: '7px'}}>
                                        <strong style={{ textTransform: 'uppercase' }}>{categoria}: </strong>
                                        {categoria === 'RIESGOS GENERALES' && listaRiesgos.join(', ')}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                {/* MEDIDAS CORRECTORAS */}
                <table style={s.table}>
                    <thead>
                        <tr style={{ height: '40px' }}>
                            <th style={{ ...s.th, width: '25%', textAlign: 'center', verticalAlign: 'middle' }}>
                                <span style={{ textDecoration: 'underline' }}>MEDIDAS CORRECTORAS</span>
                            </th>
                            
                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                REALIZADO JEFE TRABAJO (en campo)
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('medidas', 'Jefe de Trabajo').firma_path && <img src={getFirma('medidas', 'Jefe de Trabajo').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('medidas', 'Jefe de Trabajo').nombre}<br/>
                                {getFirma('medidas', 'Jefe de Trabajo').fecha_hora}<br/>
                            </th>

                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                RECURSO PREVENTIVO (en campo)
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('medidas', 'Recurso Preventivo').firma_path && <img src={getFirma('medidas', 'Recurso Preventivo').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('medidas', 'Recurso Preventivo').nombre}<br/>
                                {getFirma('medidas', 'Recurso Preventivo').fecha_hora}<br/>
                            </th>

                            <th style={{ ...s.th, width: '11%', textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px' }}>
                                RESPONSABLE CONTRATA (en campo)*
                            </th>
                            <th style={{ ...s.th, width: '14%', backgroundColor: '#fff', verticalAlign: 'bottom', textAlign: 'center', padding: '4px 2px' }}>
                                <div style={s.signBox}>{getFirma('medidas', 'Resp. Contrata').firma_path && <img src={getFirma('medidas', 'Resp. Contrata').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('medidas', 'Resp. Contrata').nombre}<br/>
                                {getFirma('medidas', 'Resp. Contrata').fecha_hora}<br/>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="5" style={{...s.td, borderBottom: '1px solid black'}}>
                                {(() => {
                                    const medidas = getMedidas();
                                    const mitad = Math.ceil(medidas.length / 2);
                                    const col1 = medidas.slice(0, mitad);
                                    const col2 = medidas.slice(mitad);

                                    return (
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '50%', paddingRight: '5px' }}>
                                                <ul style={{ margin: 0, paddingLeft: '15px', fontSize: '7px'}}>
                                                    {col1.map((m, i) => <li key={`c1-${i}`}>{m}</li>)}
                                                </ul>
                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <ul style={{ margin: 0, paddingLeft: '15px', fontSize: '7px'}}>
                                                    {col2.map((m, i) => <li key={`c2-${i}`}>{m}</li>)}
                                                </ul>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </td>
                            <td style={{...s.td, border: '1px solid black', alignContent: 'center', fontSize: '6.5px'}} colSpan="2">
                                * El Responsable de la subcontrata actuará también como Recurso Preventivo en los trabajos afectados por el RD 1627/97.
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* OBSERVACIONES */}
                <table style={s.table}>
                    <thead><tr><th style={{...s.th, textDecoration: 'underline' }}>OBSERVACIONES</th></tr></thead>
                    <tbody>
                        <tr>
                            <td style={s.td}>
                                <strong>Recurso Preventivo Designado:</strong> {ptw.recurso_preventivo_nombre}<br/><br/>
                                <strong>Descripción: </strong> {ptw.descripcion_trabajo} {ptw.observaciones}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* APERTURA */}
                <table style={s.table}>
                    <thead><tr><th colSpan="4" style={{...s.th, backgroundColor: '#c8e6c9', textDecoration: 'underline'}}>APERTURA</th></tr></thead>
                    <tbody>
                        <tr>
                            {['Jefe Trabajo', 'Resp. Contrata', 'Recurso Prev.', 'Jefe de Turno'].map(rol => {
                                const rolMap = rol === 'Resp. Contrata' && !intervieneSubcontrata ? null : rol;
                                const rFirma = getFirma('apertura', rolMap);
                                if (!rolMap) return <td key={rol} style={{...s.td, width: '25%', borderBottom: '1px solid black'}}></td>;
                                return (
                                    <td key={rol} style={{...s.td, width: '25%', verticalAlign: 'top', borderBottom: '1px solid black'}}>
                                        <strong style={{textAlign: 'center', fontSize: '8px'}}>{rol}</strong><br/>
                                        <div style={s.signBox}>{rFirma.firma_path && <img src={rFirma.firma_path} style={s.signImg} alt="sig"/>}</div>
                                        <div style={{ fontSize: '8px', marginTop: '4px' }}>
                                                <div style={{ marginBottom: '2px', fontSize: '6.5px' }}>Nombre: {rFirma.nombre}</div>
                                                <div style={{ marginBottom: '2px', fontSize: '6.5px' }}>Fecha/Hora: {rFirma.fecha_hora}</div>
                                                {rol === 'Jefe de Turno' ? (
                                                    <div style={{ marginTop: '2px', fontSize: '6.5px' }}>
                                                        <div>DESDE: {rFirma.hora_desde || '--:--'} HORAS</div>
                                                        <div style={{ marginTop: '2px' }}>HASTA: {rFirma.hora_hasta || '--:--'} HORAS</div>
                                                    </div>
                                                ) : (
                                                    <div style={{ marginTop: '2px', fontSize: '6.5px' }}>
                                                        Teléfono: {rFirma.telefono || 'Sin especificar'}
                                                    </div>
                                                )}
                                            </div>
                                        {rol === 'Resp. Contrata' && (
                                                <div style={{marginTop: 'auto',paddingTop: '6px'}}>
                                                    <div style={{fontSize: '5.5px',fontWeight: 'bold',backgroundColor: '#f5f5f5',padding: '4px',borderRadius: '2px'}}>
                                                        * El Responsable de la subcontrata actuará también como Recurso Preventivo en los trabajos afectados por el RD 1627/97.
                                                    </div>
                                                </div>
                                            )}
                                    </td>
                                );
                            })}
                        </tr>
                    </tbody>
                </table>

                {/* RENOVACIONES */}
                <table style={s.table}>
                    <tbody>
                        {/* FECHA Y HORA */}
                        <tr>
                            <td rowSpan="7" style={{ ...s.th, width: '4%', textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#e0e0e0', padding: 0, border: '0.5px solid black' }}>
                                <div style={{ fontSize: '9px', fontWeight: 'bold', letterSpacing: '1px', lineHeight: '1.2' }}>
                                    R<br/>E<br/>N<br/>O<br/>V<br/>A<br/>C<br/>I<br/>O<br/>N<br/>E<br/>S
                                </div>
                            </td>
                            <td style={{ ...s.td, width: '18%', textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold', border: '0.5px dotted black' }}>
                                FECHA Y HORA:
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => {
                                const f = renovaciones[i]?.firmas['Jefe de Turno'];
                                return (
                                    <td key={`fecha-${i}`} style={{ ...s.td, width: '13%', textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold', fontSize: '7px', border: '0.5px dotted black' }}>
                                        {f?.fecha_hora || ''}
                                    </td>
                                );
                            })}
                        </tr>

                        {/* DESDE HORA */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold', border: '0.5px dotted black' }}>
                                DESDE HORA:
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => (
                                <td key={`desde-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                    {renovaciones[i]?.firmas['Jefe de Turno']?.hora_desde || ''}
                                </td>
                            ))}
                        </tr>

                        {/* HASTA HORA */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold', border: '0.5px dotted black' }}>
                                HASTA HORA:
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => (
                                <td key={`hasta-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                    {renovaciones[i]?.firmas['Jefe de Turno']?.hora_hasta || ''}
                                </td>
                            ))}
                        </tr>

                        {/* RECURSO PREVENTIVO */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                <strong>RECURSO PREVENTIVO:</strong><br/>
                                <span style={{fontSize: '7px'}}>Nombre y firma</span>
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => {
                                const f = renovaciones[i]?.firmas['Recurso Prev.'];
                                return (
                                    <td key={`rp-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'bottom', height: '40px', backgroundColor: '#fff', border: '0.5px dotted black' }}>
                                        <div style={{ height: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {f?.firma_path && <img src={f.firma_path} style={s.signImg} alt="sig"/>}
                                        </div>
                                        <div style={{ fontSize: '7px' }}>{f?.nombre || ''}</div>
                                    </td>
                                );
                            })}
                        </tr>

                        {/* RESPONSABLE DE SUBCONTRATA */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                <strong>RESPONSABLE DE<br/>SUBCONTRATA:</strong><br/>
                                <span style={{fontSize: '7px'}}>Nombre y firma</span><br/>
                                <span style={{ fontSize: '5px', fontWeight: 'normal', display: 'block', marginTop: '2px', lineHeight: '1' }}>
                                    El Responsable de la subcontrata actuará también como Recurso Preventivo en los trabajos afectados por el RD 1627/97.
                                </span>
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => {
                                const f = renovaciones[i]?.firmas['Resp. Contrata'];
                                return (
                                    <td key={`sub-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'bottom', height: '40px', backgroundColor: '#fff', border: '0.5px dotted black' }}>
                                        <div style={{ height: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {f?.firma_path && <img src={f.firma_path} style={s.signImg} alt="sig"/>}
                                        </div>
                                        <div style={{ fontSize: '7px' }}>{f?.nombre || ''}</div>
                                    </td>
                                );
                            })}
                        </tr>

                        {/* JEFE TRABAJO */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                <strong>JEFE TRABAJO:</strong><br/>
                                <span style={{fontSize: '7px'}}>Nombre y firma</span>
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => {
                                const f = renovaciones[i]?.firmas['Jefe Trabajo'];
                                return (
                                    <td key={`jt-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'bottom', height: '40px', backgroundColor: '#fff', border: '0.5px dotted black' }}>
                                        <div style={{ height: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {f?.firma_path && <img src={f.firma_path} style={s.signImg} alt="sig"/>}
                                        </div>
                                        <div style={{ fontSize: '7px' }}>{f?.nombre || ''}</div>
                                    </td>
                                );
                            })}
                        </tr>

                        {/* JEFE TURNO */}
                        <tr>
                            <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', border: '0.5px dotted black' }}>
                                <strong>JEFE TURNO:</strong><br/>
                                <span style={{fontSize: '7px'}}>Nombre y firma</span>
                            </td>
                            {[0, 1, 2, 3, 4, 5].map(i => {
                                const f = renovaciones[i]?.firmas['Jefe de Turno'];
                                return (
                                    <td key={`jtu-${i}`} style={{ ...s.td, textAlign: 'center', verticalAlign: 'bottom', height: '40px', backgroundColor: '#fff', border: '0.5px dotted black' }}>
                                        <div style={{ height: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {f?.firma_path && <img src={f.firma_path} style={s.signImg} alt="sig"/>}
                                        </div>
                                        <div style={{ fontSize: '7px' }}>{f?.nombre || ''}</div>
                                    </td>
                                );
                            })}
                        </tr>

                        {/* FILA DE TEXTO INFERIOR */}
                        <tr>
                            <td colSpan="8" style={{ ...s.td, textAlign: 'center', fontSize: '8px', border: '0.5px solid black' }}>
                                Con las firmas de renovación del Permiso de Trabajo se están validando las Medidas Correctoras y Trabajos Previos Operaciones apuntadas más arriba.
                            </td>
                        </tr>
                    </tbody>
                </table>
                {/* CIERRE */}
                <table style={s.table}>
                    <thead><tr><th colSpan="6" style={{...s.th, backgroundColor: '#ffcdd2', textDecoration: 'underline'}}>CIERRE</th></tr></thead>
                    <tbody>
                        <tr>
                            <td style={{...s.td}} colSpan='2'>
                                <strong>JEFE TRABAJO*</strong><br/>
                                <div style={s.signBox}>{getFirma('cierre', 'Jefe Trabajo').firma_path && <img src={getFirma('cierre', 'Jefe Trabajo').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('cierre', 'Jefe Trabajo').nombre}<br/>
                                {getFirma('cierre', 'Jefe Trabajo').fecha_hora}
                            </td>
                            <td style={{...s.td, width: '33%'}} colSpan='2'>
                                <strong>JEFE TURNO**</strong><br/>
                                <div style={s.signBox}>{getFirma('cierre', 'Jefe de Turno').firma_path && <img src={getFirma('cierre', 'Jefe de Turno').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('cierre', 'Jefe de Turno').nombre}<br/>
                                {getFirma('cierre', 'Jefe de Turno').fecha_hora}
                            </td>
                            <td style={{...s.td, width: '33%'}} colSpan='2'>
                                <strong>COMPROBADO EN CAMPO</strong><br/>
                                <div style={s.signBox}>{getFirma('cierre', 'Comprobado en Campo').firma_path && <img src={getFirma('cierre', 'Comprobado en Campo').firma_path} style={s.signImg} alt="sig"/>}</div>
                                {getFirma('cierre', 'Comprobado en Campo').nombre}<br/>
                                {getFirma('cierre', 'Comprobado en Campo').fecha_hora}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan='3'>
                                <p style={{fontWeight: 'bold', fontSize: '7px'}}>TELÉFONO DE EMERGENCIA SALA DE CONTROL Astes:  Xxxxxxx.</p>
                            </td>
                            <td style={{border: '1px solid black'}} colSpan='3'> 
                                <div style={s.smallText}>* La firma del Jefe de Trabajo da por concluido el mismo.</div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan='3'>
                                <div></div>
                            </td>
                            <td style={{border: '1px solid black'}} colSpan='3'> 
                                <div style={s.smallText}>** La firma del Jefe de Turno implica que la zona reúne condiciones para la puesta en servicio.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* ANOTACIONES */}
                <table style={{ ...s.table, marginTop: '8px' }}>
                    <thead>
                        <tr>
                            <th style={{ ...s.th, backgroundColor: '#fff3e0', textAlign: 'left' }}>
                                ANOTACIONES
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ ...s.td, minHeight: '40px' }}>
                                {(() => {
                                    if (!ptw.observaciones) return <span style={{ color: '#666', fontStyle: 'italic' }}>Sin anotaciones registradas.</span>;
                                    try {
                                        const anots = JSON.parse(ptw.observaciones);
                                        return anots.map((a, i) => (
                                            <div key={i} style={{ marginBottom: '6px', borderBottom: i !== anots.length -1 ? '0.5px dotted #ccc' : 'none', paddingBottom: '4px' }}>
                                                <strong style={{ fontSize: '7px', color: '#1a237e' }}>{a.fecha}: </strong>
                                                <span style={{ whiteSpace: 'pre-wrap', fontSize: '7.5px' }}>{a.texto}</span>
                                            </div>
                                        ));
                                    } catch(e) {
                                        return <span style={{ whiteSpace: 'pre-wrap' }}>{ptw.observaciones}</span>;
                                    }
                                })()}
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>

            {/* ========================================================================= */}
            {/* PÁGINA 2: TRABAJADORES DE SUBCONTRATA */}
            {/* ========================================================================= */}
            {intervieneSubcontrata && (
                <div style={{ ...s.page, pageBreakBefore: 'always' }}>
                    
                    {/* CABECERA */}
                    <div style={s.header}>
                        <div><img src={imagenFondo} style={{ maxHeight: '60px', margin: '5px' }} alt="logo" /></div>
                        <div style={{ ...s.title, width: '100%' }}>PERMISO DE TRABAJO rev05</div>
                    </div>

                    {/* DATOS DE LA EMPRESA */}
                    <table style={{ ...s.table, borderTop: 'none', marginBottom: '0' }}>
                        <tbody>
                            <tr>
                                <td style={{ ...s.tdLabel, width: '25%', textAlign: 'center' }}>EMPRESA / EMPRESAS:</td>
                                <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold' }}>
                                    {Array.from(new Set((ptw.hpt?.trabajadores || []).map(t => t.empresa).filter(Boolean))).join(', ')}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ ...s.tdLabel, textAlign: 'center' }}>PERMISO DE TRABAJO:</td>
                                <td style={{ ...s.td, textAlign: 'center', verticalAlign: 'middle' }}>{ptw.id_ptw_formato}</td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ ...s.th, textAlign: 'center', backgroundColor: '#f0f0f0' }}>
                                    TRABAJADORES INTERVINIENTES:
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* 9 TRABAJADORES (3 Filas x 3 Columnas) */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid black', tableLayout: 'fixed' }}>
                        <tbody>
                            {/* 3 filas (Empieza en 0, 3 y 6) */}
                            {[0, 3, 6].map(rowStartIdx => (
                                <tr key={rowStartIdx}>
                                    {/* 3 columnas */}
                                    {[0, 1, 2].map(colOffset => {
                                        const idx = rowStartIdx + colOffset;
                                        const t = (ptw.hpt?.trabajadores && ptw.hpt.trabajadores[idx]) ? ptw.hpt.trabajadores[idx] : null;
                                        const f = firmasSecciones?.trabajadores?.[`worker_${idx}`] || {};
                                        
                                        return (
                                            <td key={idx} style={{ border: '1px solid black', verticalAlign: 'top', padding: 0 }}>
                                                
                                                {/* TÍTULO TRABAJADOR */}
                                                <div style={{ backgroundColor: '#e0e0e0', textAlign: 'center', borderBottom: '1px solid black', fontWeight: 'bold', fontSize: '9px', padding: '3px' }}>
                                                    TRABAJADOR {idx + 1}
                                                </div>
                                                
                                                {/* DATOS PERSONALES */}
                                                <div style={{ fontSize: '7.5px', borderBottom: '1px solid black', padding: '2px 4px', height: '12px' }}>
                                                    NOMBRE: {t?.nombre || ''}
                                                </div>
                                                <div style={{ fontSize: '7.5px', borderBottom: '1px solid black', padding: '2px 4px', height: '12px' }}>
                                                    APELLIDOS: {t?.apellidos || ''}
                                                </div>
                                                
                                                {/* ZONA DE FIRMA */}
                                                <div style={{ padding: '2px 4px', height: '60px', display: 'flex', flexDirection: 'column' }}>
                                                    <div style={{ fontSize: '6px' }}>CONFORME PERMISO DE TRABAJO, REVISADOS EPI´S Y FORMACION</div>
                                                    <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        {f.firma_path && <img src={f.firma_path} style={{ maxHeight: '35px', maxWidth: '100%' }} alt="firma"/>}
                                                    </div>
                                                    <div style={{ fontSize: '6px', color: '#1a237e' }}>
                                                        (NOMBRE, FIRMA FECHA Y HORA) {f.fecha_hora ? `- ${f.fecha_hora}` : ''}
                                                    </div>
                                                </div>
                                                
                                                {/* CHECKLIST DE HABILITACIONES */}
                                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '5.5px' }}>
                                                    <tbody>
                                                        {[
                                                            { key: 'info', label: '¿Se ha informado de Riesgos y Medidas Correctoras?', bold: true },
                                                            { key: 'epis', label: 'ESTADO GENERAL DE LOS EPI´S CORRECTO', bold: true },
                                                            { key: 'carretilla_elevadora', label: 'CARRETILLA ELEVADORA' },
                                                            { key: 'carretilla_telescopica', label: 'CARRETILLA ELEVADORA TELESCOPICA' },
                                                            { key: 'plataforma_elevadora', label: 'PLATAFORMA ELEVADORA' },
                                                            { key: 'puente_grua', label: 'PUENTE GRUA' },
                                                            { key: 'espacios_confinados', label: 'ESPACIOS CONFINADOS' },
                                                            { key: 'baja_tension', label: 'BAJA TENSION' },
                                                            { key: 'alta_tension', label: 'ALTA TENSION' },
                                                            { key: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', highlightSI: true },
                                                            { key: 'camion_pluma', label: 'CAMION PLUMA' },
                                                            { key: 'grua', label: 'GRUA' },
                                                            { key: 'otros', label: 'OTROS:' }
                                                        ].map((item, itemIdx) => {
                                                            let hasSkill = false;
                                                            let label = item.label;
                                                            
                                                            // Lógica para marcar los SI/NO
                                                            if (t) {
                                                                if (item.key === 'info' || item.key === 'epis') {
                                                                    hasSkill = true; // Por defecto se dan por informados si están en la lista
                                                                } else if (item.key === 'otros') {
                                                                    hasSkill = !!(t.otros && t.otros.trim() !== '');
                                                                    if (hasSkill) label = `OTROS: ${t.otros}`;
                                                                } else {
                                                                    hasSkill = !!t[item.key];
                                                                }
                                                            }

                                                            return (
                                                                <tr key={itemIdx}>
                                                                    <td style={{ borderTop: '1px solid black', borderRight: '1px solid black', padding: '2px', fontWeight: item.bold ? 'bold' : 'normal', height: '10px' }}>
                                                                        {label}
                                                                    </td>
                                                                    {/* CELDA SI */}
                                                                    <td style={{ borderTop: '1px solid black', borderRight: '1px solid black', width: '12px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: (hasSkill && item.highlightSI) ? '#ffeb3b' : 'transparent', fontWeight: 'bold' }}>
                                                                        {hasSkill ? 'SI' : ''}
                                                                    </td>
                                                                    {/* CELDA NO */}
                                                                    <td style={{ borderTop: '1px solid black', width: '12px', textAlign: 'center', verticalAlign: 'middle' }}>
                                                                        {!hasSkill && t ? 'NO' : ''}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
});

export default PTWPdfTemplate;